import Vue from 'vue'
import config from '@/config'

export default {
  SET_AGENCIES (state, payload) {
    state.agencies = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('agencies', JSON.stringify(payload))
    }
  },

  SET_COMPANIES (state, payload) {
    state.companies = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('companies', JSON.stringify(payload))
    }
  },

  SELECT_AGENCY (state, payload) {
    state.selectedAgency = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('selectedAgency', JSON.stringify(payload))
    }
  },

  SELECT_COMPANY (state, payload) {
    state.selectedCompany = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('selectedCompany', JSON.stringify(payload))
    }
  },

  SET_DEBUG_MODE (state, payload) {
    state.isDebugMode = payload

    if (config.KEEP_LOGGED_IN) {
      Vue.localStorage.set('isDebugMode', payload)
    }
  },

  SET_CURRENT_TAB (state, payload) {
    state.currentTabId = payload
  },

  SET_IS_LOADING (state, payload) {
    setTimeout(() => {
      state.isLoading = payload
    }, payload ? 0 : 200)
  },

  SET_OPEN_GROUPS (state, payload) {
    state.openGroups = payload
  },

  SET_OPEN_SUB_SECTIONS (state, payload) {
    state.openSubSections = payload
  },

  SET_SIDEBAR_VISIBLE (state, payload) {
    state.sidebarVisible = payload
  },

  SET_SHOW_EMPTY_NOTICE (state, payload) {
    state.showEmptyNotice = payload
  },

  SET_SHOW_CUSTOMER_PREF (state, payload) {
    state.showCustomerPref = payload
  },

  SET_CONCEPT_EDIT (state, payload) {
    state.isConceptEdit = payload
  },

  SET_HAS_CONCEPT (state, payload) {
    state.hasConcept = payload
  },

  SET_CONSULTATION_ID (state, payload) {
    state.consultationId = payload
  }
}
